import {mapState} from 'vuex';
import utils from '@/common/libs/utils.js';

export default{
  name: 'LocationChange',
  data() {
    return {
      show: false
    }
  },
  computed: mapState({
    location: state => state.home.location,
    isLocationChanged: state => state.home.isLocationChanged
  }),
  watch: {
    location: {
      handler: function(newVal) {
        if (this.$route.params.city !== newVal.first_word && this.isLocationChanged == 1 ) {
          if (utils.cookie.get('cardChangeCity') && utils.cookie.get('cardChangeCity') ==1){
            this.show = false;
          } else if (this.$route.params.city) {
            //定位城市和域名中的默认城市不一样，弹出弹窗，询问是否切换城市
            this.show = true;
          }
          
        }
      },
      deep: true
    }
  },
  methods: {
    ok() {
      this.$store.commit('setCity', this.location);
      this.show = false;

      this.buryPoint('切换按钮');

      let path = this.$route.fullPath.split('/');

      path[1] = this.location.first_word;

      //this.$router.push({path: path.join('/')});
      window.location.href = path.join('/');
    },
    forgetIt() {
      this.show = false;
      this.$store.commit('setIsLocationChanged', 2);
      this.buryPoint('算了吧按钮');
    },
    buryPoint(point) {
      utils.bury('yd_izhikang_city_swich', {
        'locate_city': this.location.city_name,
        'button_name': point
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/public/locationChange/LocationChangeVm.js